import React,  { Component } from 'react'


class Voldemort extends Component {

    constructor(props) 
    {
        super(props);
        this.state = {
            show: true
        };
        this.showOff=this.showOff.bind(this);
        setTimeout(this.showOff, 400)
    }

    showOff()
    {
        this.setState({show:false});
    }

    componentDidMount() 
    {
        
    }

    render()
    {
        if(this.state.show)
        {
            return (
                
                <img src={"/img/Voldemort1.jpg"} alt="You-Know-Who"/>
            );
        }
        
        return "---";
    }
}


export default Voldemort;
